var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('circle-trail-bar-chart-label');
export var CircleTrailBarChartLabelDefaultProps = {};
export var CircleTrailBarChartLabelSizesBase = {
  small: '0.9em',
  default: '0.9em',
  medium: '0.95em',
  large: '1em'
};
export var CircleTrailBarChartLabelSizes = {
  small: '0.9em',
  default: '1.25em',
  medium: '1.35em',
  large: '1.45em'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 400;\n    word-break: break-word;\n    padding-right: ", ";\n    ", "\n\n    ", "\n\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  "], ["\n    font-weight: 400;\n    word-break: break-word;\n    padding-right: ", ";\n    ", "\n\n    ", "\n\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  "])), theme.UNIT(4), function (_a) {
    var item = _a.item;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: ", ";\n      font-family: ", ";\n    "], ["\n      font-size: ", ";\n      font-family: ", ";\n    "])), item.labelSize || CircleTrailBarChartLabelSizesBase[item.size || 'default'], theme.FONT(item.labelFont || 'sans'));
  }, function (_a) {
    var clickable = _a.clickable;
    return clickable && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
  }),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    word-break: none;\n    ", "\n\n  "], ["\n    word-break: none;\n    ", "\n\n  "])), function (_a) {
    var item = _a.item;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), item.labelSize || CircleTrailBarChartLabelSizes[item.size || 'default']);
  })
});
// -------- Components -------->
var My = {
  Container: styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var CircleTrailBarChartLabel = function (props) {
  var className = props.className,
    item = props.item,
    onClick = props.onClick;
  if (!item) {
    return null;
  }
  var clickable = !!(onClick || item.onCircleClick);
  return React.createElement(My.Container, {
    clickable: clickable,
    onClick: item.onLabelClick || onClick,
    title: item.label,
    item: item,
    className: cls.name(className)
  }, item.label);
};
CircleTrailBarChartLabel.defaultProps = CircleTrailBarChartLabelDefaultProps;
CircleTrailBarChartLabel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;